import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../services/jrni/api.service';
import { DatastoreService } from '../services';
import { AvailabilityService } from '../services/jrni/availability.service';
import moment from 'moment';

@Component({
  selector: 'app-cost-breakdown',
  templateUrl: './cost-breakdown.component.html',
  styleUrls: ['./cost-breakdown.component.scss'],
})
export class CostBreakdownComponent implements OnInit {
  @Input() costBreakDown: any;
  @Input() company: any;
  @Input() service: any;
  @Input() currentPage: any;
  ceremonyDateId: number;
  date: string;
  ceremonyDate: any;
  showBudgetCode = false;
  // fees: any = [];
  totalCost: any;
  daysAway: number = 0;
  costTotal: number = 0;
  depositTotal: number = 0;
  // True when /fees answered 404: this booking has no configured price and
  // must not be bookable online. It is NOT free.
  feesUnavailable = false;

  constructor(
    private apiService: ApiService,
    public dataStore: DatastoreService,
    private availabilityService: AvailabilityService
  ) {}

  ngOnInit(): void {
    this.dataStore.serviceFees = [];

    // if currentPage is "/summary" then show budget code
    if (this.currentPage === '/summary' && this.dataStore.adminJourney) {
      this.showBudgetCode = true;
    }

    this.dataStore.addFees$.subscribe((feeToAdd) => {
      if (feeToAdd) {
        console.log(feeToAdd);
        this.dataStore.serviceFees = this.dataStore.serviceFees.filter(
          (item) => item.questionid !== feeToAdd.questionid
        );
        this.dataStore.serviceFees.push({
          questionid: feeToAdd.questionid,
          item: feeToAdd.item,
          quantity: feeToAdd.quantity,
          cost: feeToAdd.cost,
          deposit: feeToAdd.cost,
          budget_code: feeToAdd.payment_code,
        });
        console.log(this.dataStore.serviceFees);
        this.calculateTotal();
      }
    });

    if (!this.company) {
      this.company = this.dataStore.selectedDepartment;
    }

    if (!this.service) {
      this.service = this.dataStore.selectedService;
    }

    // if (!this.ceremonyDateId) {
    //   if (this.dataStore.config.hasOwnProperty('journey_config')) {
    //     if (this.dataStore.config.journey_config.hasOwnProperty('ceremonies')) {
    //       if (this.dataStore.config.journey_config.ceremonies.hasOwnProperty('ceremony_date_question')) {
    //         this.ceremonyDateId = parseInt(this.dataStore.config.journey_config.ceremonies.ceremony_date_question);
    //       }
    //     }
    //   }
    // }
    this.calculate().catch((error) => {
      // /fees could not price this (404 = missing fee row; reason logged by the
      // api service). Never fall through to a £0 breakdown: flag the journey as
      // unpriced so the template explains and the summary refuses checkout.
      console.error('cost-breakdown: unpriced — blocking online checkout', error);
      this.feesUnavailable = true;
      this.dataStore.feesUnavailable = true;
      this.dataStore.serviceFees = [];
    });
  }

  async calculate() {
    this.feesUnavailable = false;
    this.dataStore.feesUnavailable = false;
    // console.log('ceremonyDateId', this.ceremonyDateId);
    // if (this.ceremonyDateId) {
    //   const dateVal = this.dataStore.companyQuestionsForm.get(`${this.ceremonyDateId}`).value;
    //   this.ceremonyDate = moment(dateVal).format('YYYY-MM-DD');
    // }
    // console.log(this.ceremonyDate);
    const slot = await this.availabilityService.getSelectedSlot();
    console.log(slot);
    if (slot) {
      this.date = moment(slot.start).format('YYYY-MM-DD HH:mm:ss');
      this.daysAway = moment(slot.start).diff(moment(), 'd');
    }

    // if (this.ceremonyDate) {
    //   this.daysAway = moment(this.ceremonyDate).diff(moment(), 'd')
    // }

    if (this.date) {
      const fee: any = await this.apiService.fees(
        this.company.id,
        this.date,
        this.service.id,
        this.service.calculated_duration
      );
      this.dataStore.serviceFees = this.dataStore.serviceFees.filter(
        (item) => item.questionid !== fee['questionid']
      );
      this.dataStore.serviceFees.push({
        questionid: fee['questionid'],
        item: this.service.name,
        quantity: 1,
        cost: fee['full_fee'],
        deposit: fee['deposit'],
        budget_code:  fee['payment_code']
      });

      if (fee.short_notice > 0) {
        if (
          this.service.extra?.hasOwnProperty('fees_extra_item_short_notice_id')
        ) {
          const extraItemShortNoticeId =
            this.service.extra.fees_extra_item_short_notice_id;
          const extraItem: any = await this.apiService.getExtraItem(
            this.company.id,
            this.service.id,
            extraItemShortNoticeId
          );
          console.log(extraItem);
          this.dataStore.serviceFees.push({
            questionid: 'noid1',
            item: extraItem.item_name,
            quantity: 1,
            cost: extraItem.item_price,
            deposit: extraItem.item_price,
            item_id: extraItemShortNoticeId,
            budget_code: extraItem.data.short_code
          });
        }
      }

      if (fee.out_of_hours > 0) {
        // get the day
        let extraItemOutOfHoursId: any = false;
        const dayOfWeek = moment(this.date).format('ddd');
        if (fee.is_bank_holiday || dayOfWeek === 'Sun') {
          if (
            this.service.extra?.hasOwnProperty(
              'fees_extra_item_out_of_hours_sun_bank_hol_id'
            )
          ) {
            extraItemOutOfHoursId =
              this.service.extra.fees_extra_item_out_of_hours_sun_bank_hol_id;
          }
        } else {
          if (
            this.service.extra?.hasOwnProperty(
              'fees_extra_item_out_of_hours_mon_sat_id'
            )
          ) {
            extraItemOutOfHoursId =
              this.service.extra.fees_extra_item_out_of_hours_mon_sat_id;
          }
        }
        if (extraItemOutOfHoursId) {
          const extraItem: any = await this.apiService.getExtraItem(
            this.company.id,
            this.service.id,
            extraItemOutOfHoursId
          );
          console.log(extraItem);
          this.dataStore.serviceFees.push({
            questionid: 'noid2',
            item: extraItem.item_name,
            quantity: 1,
            cost: extraItem.item_price,
            deposit: extraItem.item_price,
            item_id: extraItemOutOfHoursId,
            budget_code: extraItem.data.short_code
          });
        }
      }

      console.log(this.dataStore.serviceFees);
    }

    // if (this.daysAway > 182) {
    //   this.totalCost = this.fees.reduce((sum, fee) => sum + fee.deposit, 0);
    // }
    // else {
    //   this.totalCost = this.fees.reduce((sum, fee) => sum + fee.full_fee, 0);
    // }
    this.calculateTotal();
  }

  calculateTotal() {
    let costTotal = 0;
    let depositTotal = 0;
    costTotal = this.dataStore.serviceFees.reduce(
      (sum, fee) => sum + fee.cost * fee.quantity,
      0
    );
    if (this.daysAway > 182) {
      this.totalCost = this.dataStore.serviceFees.reduce(
        (sum, fee) => sum + fee.deposit * fee.quantity,
        0
      );
      depositTotal = this.dataStore.serviceFees.reduce(
        (sum, fee) => sum + fee.deposit * fee.quantity,
        0
      );
    } else {
      this.totalCost = this.dataStore.serviceFees.reduce(
        (sum, fee) => sum + fee.cost * fee.quantity,
        0
      );
    }
    this.dataStore.serviceFees = this.dataStore.serviceFees.sort(
      (a, b) => b.cost - a.cost
    );
    this.dataStore.totalCost = this.totalCost;
    this.costTotal = costTotal;
    this.depositTotal = depositTotal;
    console.log('costTotal', costTotal, 'depositTotal', depositTotal);
  }
}
